import React from "react";
import ButtonMflPlayer from "shared/components/buttons/ButtonMflPlayer.js";
import "./Item.css";

const ItemRowPlayer = ({ p, clubId }) => {
  return (
    <div className="Item ItemRowPlayer no-hover w-100" style={{ backgroundColor: "transparent" }}>
      <div className="d-flex flex-column flex-md-row flex-fill pb-1 pb-md-0">
        <div className="d-flex flex-row flex-md-basis-300">
          <img
            src={`https://d13e14gtps4iwl.cloudfront.net/u/clubs/${clubId}/logo.webp`}
            alt={`${clubId} logo`}
            style={{ width: "15px", height: "15px", marginTop: "3px", marginRight: "3px" }}
          />

          <div className="d-flex fill">
            {p?.metadata?.firstName} {p?.metadata?.lastName}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemRowPlayer;
